let FelcanaProApi = require('symptom_checker_api');
let FelcanaProAppApi = require('felcana_api');

let defaultClient = FelcanaProApi.ApiClient.instance;
defaultClient.basePath = process.env["VUE_APP_BASE_URL"];
let defaultAppClient = FelcanaProAppApi.ApiClient.instance;
defaultAppClient.basePath = process.env["VUE_APP_FELCANA_WEB_BASE_URL"];
// Configure API key authorization: api_key

// Uncomment the following line to set a prefix for the API key, e.g. "Token" (defaults to null)
let api_key = defaultClient.authentications.api_key;
api_key.apiKeyPrefix = 'Token';

export const apiInstance = new FelcanaProApi.ApiApi();
export const restAuthApiInstance = new FelcanaProApi.RestAuthApi();

export const userApiInstance = new FelcanaProAppApi.UserApi();
export const petApiInstance = new FelcanaProAppApi.PetApi();
export const tokenApiInstance = new FelcanaProAppApi.TokenApi();